import React from "react";
import { FaRegSquare, FaSearch, FaSquare, FaThumbsDown, FaThumbsUp } from "react-icons/fa";
import Rating from "react-rating";
import Popup from "reactjs-popup";

import { hotelRatings, hotelRatingsText, hotelReviewDetailsText, hotelReviewsText } from "../utils";

const nf = new Intl.NumberFormat("de-DE");

export default function HotelReviews(props) {
  const { hotel } = props;

  let odd = true;


  let detailedRating = {
    academicTitle: "",
    advice: "Supermarkt weit weg",
    age: "41-45",
    category: "4.5",
    conclusion: "Supermarkt weit weg",
    conclusionModified: false,
    customerID: 691006,
    firstName: "Mao Y.",
    headline: "Gute Erholung",
    headlineModified: false,
    hotelRatingDetailsActivities:
    {
      conclusion: "",
      conclusionModified: false,
      courses: 0,
      diversity: 0,
      hotelactivities: 0,
      offer: 0,
      quality: 0
    },
    hotelRatingDetailsBeach:
    {
      conclusion: "",
      conclusionModified: false,
      condition: "sand",
      environment: 6,
      gastronomy: 5,
      possibilityOfSport: 5,
      reachability: 6,
      size: 5
    },
    hotelRatingDetailsCulture:
    {
      conclusion: "",
      conclusionModified: false,
      events: 0,
      galleries: 0,
      guidedTours: 0,
      museums: 0,
      parks: 0,
      sights: 0,
      theatre: 0
    },
    hotelRatingDetailsEatAndDrink:
    {
      allInclusive: 0,
      cleanness: 5,
      conclusion: "",
      conclusionModified: false,
      drinks: 6,
      food: 5
    },
    hotelRatingDetailsFamily:
    {
      animationForChildren: 5,
      childCare: 6,
      childOrientedFood: 5,
      childrensPlayground: 5,
      conclusion: "",
      conclusionModified: false,
      poolForChildren: 5
    },
    hotelRatingDetailsHotel:
    {
      cleanness: 5,
      conclusion: "",
      conclusionModified: false,
      recreationalValue: 5,
      suitableForCouple: 5,
      suitableForFamily: 6,
      suitableForGroup: 4,
      suitableForSingle: 2
    },
    hotelRatingDetailsInfrastructure:
    {
      airport: 0,
      carRental: 0,
      conclusion: "",
      conclusionModified: false,
      railwayStation: 0,
      touristInformation: 0,
      transportation: 0
    },
    hotelRatingDetailsLocation:
    {
      conclusion: "",
      conclusionModified: false,
      distanceToBeach: 6,
      party: 4,
      possibilityOfExcursion: 4,
      possibilityOfRecreation: 4,
      possibilityOfShopping: 3,
      restaurants: 4
    },
    hotelRatingDetailsPool:
    {
      cleanness: 5,
      conclusion: "",
      conclusionModified: false,
      flume: 0,
      recreationalValue: 5,
      size: 5
    },
    hotelRatingDetailsRoom:
    {
      bath: 4,
      cleanness: 4,
      conclusion: "unbequestes bett",
      conclusionModified: false,
      design: 5,
      environment: 4,
      size: 4
    },
    hotelRatingDetailsService:
    {
      conclusion: "Rezeption personal lustlos Bedingungen am Ess-Tisch Top",
      conclusionModified: false,
      germanSpeaking: 6,
      reception: 4,
      staff: 4
    },
    hotelRatingDetailsSkiArea:
    {
      accessibilityLift: 0,
      advanced: 0,
      alpineskiing: 0,
      beginners: 0,
      conclusion: "",
      conclusionModified: false,
      crosscountry: 0,
      slopeDiversity: 0,
      slopeQuality: 0,
      snowboard: 0
    },
    hotelRatingDetailsSport:
    {
      animation: 5,
      conclusion: "",
      conclusionModified: false,
      fitnessClub: 0,
      golf: 0,
      possibilityOfSport: 5,
      sportsEquipment: 4,
      tennis: 5
    },
    hotelRatingDetailsWellness:
    {
      ambiance: 0,
      conclusion: "",
      conclusionModified: false,
      cosmetics: 0,
      hotSprings: 0,
      massage: 0,
      sauna: 0
    },
    hotelRatingDetailsWinterSportOffer:
    {
      apresSki: 0,
      conclusion: "",
      conclusionModified: false,
      courseOffered: 0,
      skiRental: 0,
      skiSchool: 0,
      skipass: 0,
      winterSportFacilities: 0
    },
    hotelRatingDetailsHygiene: {
      checkIn: 1,
      distancing: 2,
      contaclessCatering: 1,
      takeAway: 2,
      disinfectionsAndMasks: 1,
      conclusion: "",
      conclusionModified: false
    },
    hotelname: "Kefalos Beach Holiday Village",
    monthOfTravel: 6,
    picturesFromTraveller: [],
    ratingActivities: 0,
    ratingAllOver: "4.7",
    ratingBeach: 4,
    ratingCulture: 0,
    ratingEatAndDrink: 5,
    ratingFamily: 5,
    ratingHotel: 5,
    ratingID: "61f5bf3348b8ed943b85b417485f27fe",
    ratingInfrastructure: 0,
    ratingLocation: 4,
    ratingPool: 5,
    ratingRoom: 4,
    ratingService: 5,
    ratingSkiArea: 0,
    ratingSport: 5,
    ratingWellness: 0,
    ratingWinterSportOffer: 0,
    recommendation: true,
    surname: "Ye",
    title: "Herr",
    tourOperatorSatisfaction: 0,
    travelledAs: "Familie",
    typeOfTravel: "Badeurlaub",
    reviewCreated: "2022-06-24T10:00:00",
    yearOfTravel: 2022
  };
  return (
    <>
      <span style={{ fontWeight: 700 }}>{detailedRating.headline}</span><div><span style={{ fontWeight: 600 }}>Weiterempfehlung:</span> {detailedRating.recommendation ? <FaThumbsUp /> : <FaThumbsDown />} </div>
      <div style={{ display: "flex", }}><div style={{ flex: "33%" }}>{detailedRating.title} {detailedRating.firstName} {detailedRating.surname} ({detailedRating.age} Jahre) </div><div style={{ flex: "33%" }}><span style={{ fontWeight: 600 }}>Bewertung:</span> {nf.format(detailedRating.ratingAllOver * 1)} von 6,0 </div>

        <div style={{ flex: "33%" }}></div>
      </div>
      <div style={{ display: "flex", }}>
        <div style={{ flex: "33%" }}><span style={{ fontWeight: 600 }}>Reisedatum:</span> {detailedRating.monthOfTravel}/{detailedRating.yearOfTravel} </div>
        <div style={{ flex: "33%" }}><span style={{ fontWeight: 600 }}>Verreist als:</span> {detailedRating.travelledAs} </div>
        <div style={{ flex: "33%" }}><span style={{ fontWeight: 600 }}>Reiseart:</span> {detailedRating.typeOfTravel}</div></div>
      <br />

      {detailedRating.advice}  <br /><br />


      <div style={{
        display: "flex", flexFlow: "row wrap",
        justifyContent: "space-between",
      }}>

        <ReviewRating label="Hotel" popupLabel={"des Hotels"} value={"ratingHotel"} data={detailedRating} />
        <ReviewRating label="Zimmer" popupLabel={"des Zimmers"} value={"ratingRoom"} data={detailedRating} />
        <ReviewRating label="Lage" popupLabel={"der Lage"} value={"ratingLocation"} data={detailedRating} />
        <ReviewRating label="Service" popupLabel={"des Service"} value={"ratingService"} data={detailedRating} />
        <ReviewRating label="Essen & Trinken" popupLabel={"des Essens & Trinkens"} value={"ratingEatAndDrink"} data={detailedRating} />
        <ReviewRating label="Strand" popupLabel={"des Strands"} value={"ratingBeach"} data={detailedRating} />
        <ReviewRating label="Pool" popupLabel={"des Pools"} value={"ratingPool"} data={detailedRating} />
        <ReviewRating label="Sportangebot" popupLabel={"des Sportangebots"} value={"ratingSport"} data={detailedRating} />
        <ReviewRating label="Kulturangebot" popupLabel={"des Kulturangebots"} value={"ratingCulture"} data={detailedRating} />


      </div>
      {
        Object.keys(detailedRating).map((e) => {
          if (detailedRating[e].conclusion) {
            return <span><br /><br /> <span style={{ fontWeight: 600 }}>{hotelReviewsText(e)}</span> < br /> {detailedRating[e].conclusion}</span>
          }
          else
            return null;
        })
      }
      <span><br /><br /> <span style={{ fontWeight: 600 }}>Gesamt</span> < br /> {detailedRating.conclusion}</span>
    </>
  );
}


const ReviewRating = (props) => {
  const { label, data, value, popupLabel } = props;
  const [showRatings, setShowRatings] = React.useState(false);
  const detailvalue = "hotelRatingDetails" + value.replace("rating", "");
  return <>{data[value] > 0 && <div style={{ flex: "25%" }}>
    <span style={{ cursor: "pointer" }} onClick={() => setShowRatings(true)}>{label} <FaSearch size={12} /></span>&nbsp;<span style={{ fontSize: "0.7em" }}>({data[value]} von 6,0)</span><br />
    <Rating start={0} stop={6} emptySymbol={<FaRegSquare className="ratings" />}
      fullSymbol={<FaSquare className="ratings" />} initialRating={data[value]} readonly />
  </div>}
    <Popup
      open={showRatings}
      position="center"
      modal
      onClose={() => {
        setShowRatings(false);
      }}
    >
      <div className="infopopup">
        <span style={{ fontWeight: 600 }}>Einzelbewertungen {popupLabel}</span>
        <br />
        {Object.keys(data[detailvalue]).map((e) => {

          return !isNaN(data[detailvalue][e]) && data[detailvalue][e] > 0 ? (<><br /><br />{hotelReviewDetailsText(e)}&nbsp;<span style={{ fontSize: "0.7em" }}>({data[detailvalue][e]} von 6,0)</span><br /><Rating onHover={(e) => { console.log(e) }} start={0} stop={6} emptySymbol={<FaRegSquare className="ratings" />}
            fullSymbol={<FaSquare className="ratings" />} initialRating={data[detailvalue][e]} readonly />&nbsp;</>) : null
        })}
      </div>
    </Popup>
  </>
}